import { Player } from 'src/mundial/requests/interfaces';
import { subMenu } from './index';
import Translator from '../../../../requests/apa/Translator';
import {SOCCERPLAYER, VCARDPARTIDO} from './constants'
import { RouteComponentProps } from 'react-router-dom';

enum Order {
    ASC = 'asc',
    DESC = 'desc',
}

export const getPercentage = (value: number): number => {
    return value > 0 ? (1 / value) * 100 : 0;
};

export const splitLocationOfHistory = (history: RouteComponentProps): string[] => {
  const { location:{ pathname } } = history
  const splitLocation = pathname.split('/')
  return splitLocation
}

export const getMatchId = (location?: any) => {
    const url =  location ? location.pathname: window.location.pathname;
    const urlSplit = url.split('/');
    const matchId = urlSplit.length >= 3 ? url.split('/')[3] : '';
    return matchId;
};

export const sortPlayersDesc = (valueNow: Player, valueAfter: Player, type: Order = Order.DESC) => {
    const valueMinor = type === Order.DESC ? 1 : -1;
    const valueMajor = type === Order.DESC ? -1 : 1;

    const valueNowPosition = parseInt(valueNow.positionNumber || '0');
    const valueAfterPosition = parseInt(valueAfter.positionNumber || '0');

    if (valueNowPosition < valueAfterPosition) {
        return valueMinor;
    }
    if (valueNowPosition > valueAfterPosition) {
        return valueMajor;
    }
    return 0;
};

export const sortPlayersAsc = (valueNow: Player, valueAfter: Player) => {
    return sortPlayersDesc(valueNow, valueAfter, Order.ASC);
};

export const handleFocusAutoScroll = (value: number) => {
    const element = document.getElementById('scroll');
    if (element) element.scrollTop = value;
};

export const redirect = async (history: any, href: string, scroll: number, idMatch:null|string=null) => {
  const urlAux = "/mundial/vcardmatch/";
    const {
        location: { pathname },
    } = history;
    const url = pathname.split('/');
    if (url.length > 4) {
        url.splice(url.length - 1, 1);
        url.join('/');
    }
    const urlRedirect = idMatch ? `${urlAux}${idMatch}` : `${url.join('/')}${href}`;
    await history.push(urlRedirect);
    handleFocusAutoScroll(scroll);
    const element = document.getElementById('scroll')!;
    if(urlRedirect.includes('players') || urlRedirect.includes('comments') || urlRedirect.includes('resume') || urlRedirect.includes('alignments')) {
         element.style.height = "630px";
    } else {
        element.removeAttribute('style');
    }
};

export const validateImage = (url: string) => {
    const regexp = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
    let imgValid;
    if(regexp.test(url)) {
        imgValid = fetch(url).then(
            () => {
                return true;
            }).catch(
                () => {
                    return false;
                });
    } else {
        imgValid = false;
    }
    return regexp.test(url) ? imgValid : regexp.test(url);
}


export const getIdFocusable = (href: string) : string => {
  const selectedMenu = subMenu.find((item) => item.href === href);
  const playButton = document.getElementById('play-focusable');
  const idFocusableDescription = playButton ? playButton.id : 'namesTitle-focusable';
  return selectedMenu ? selectedMenu.name : idFocusableDescription;
}

export const mapPlayersToSpecialRibbonProps = (players: any, playerData: any, props: any) => {
    let location = '';
    if( props.location &&  props.location.pathname){
        location = props.location.pathname;
    }else {
        location  = VCARDPARTIDO;
    }
     
    if(players.length === undefined || players[0].id == '') return;
    const id = Math.random() * 10
    const items = players.map((t: any)=>{
      t.typeRender ="a";
      t.text_highlight = t.title;
      t.cover = null;
      t.typeTeam= playerData.typeTeam;
      return t;
    });
    return {
        id,
        type: SOCCERPLAYER,
        title: playerData.title,
        byUser:false,
        offset: null,
        showFooter: false,
        isCarrouselTV: false,
        url: "",
        items,
        index: 0,
        bottomRibbon: playerData.bottomRibbon,
        key: id,
        focusHandler:()=>{},
        forceUpdateGrid:()=>{},
        hasRecordings: false,
        visibleNumber: 7,
        idTeam: playerData.idTeam,
        typeTeam: playerData.typeTeam,
        setMetricsEvent:props.setMetricsEvent,
        location:  location,
    }
  }



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/utils/functions.ts